var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    stroke: "#8A8A8A",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C11.3807 13 12.5 11.8807 12.5 10.5C12.5 9.11929 11.3807 8 10 8C8.61929 8 7.5 9.11929 7.5 10.5C7.5 11.8807 8.61929 13 10 13Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 11.2334V9.76669C1.66675 8.90003 2.37508 8.18336 3.25008 8.18336C4.75841 8.18336 5.37508 7.11669 4.61675 5.80836C4.18341 5.05836 4.44175 4.08336 5.20008 3.65003L6.64175 2.82503C7.30008 2.43336 8.15008 2.6667 8.54175 3.32503L8.63341 3.48336C9.38341 4.79169 10.6167 4.79169 11.3751 3.48336L11.4667 3.32503C11.8584 2.6667 12.7084 2.43336 13.3667 2.82503L14.8084 3.65003C15.5667 4.08336 15.8251 5.05836 15.3917 5.80836C14.6334 7.11669 15.2501 8.18336 16.7584 8.18336C17.6251 8.18336 18.3417 8.89169 18.3417 9.76669V11.2334C18.3417 12.1 17.6334 12.8167 16.7584 12.8167C15.2501 12.8167 14.6334 13.8834 15.3917 15.1917C15.8251 15.95 15.5667 16.9167 14.8084 17.35L13.3667 18.175C12.7084 18.5667 11.8584 18.3334 11.4667 17.675L11.3751 17.5167C10.6251 16.2084 9.39175 16.2084 8.63341 17.5167L8.54175 17.675C8.15008 18.3334 7.30008 18.5667 6.64175 18.175L5.20008 17.35C4.44175 16.9167 4.18341 15.9417 4.61675 15.1917C5.37508 13.8834 4.75841 12.8167 3.25008 12.8167C2.37508 12.8167 1.66675 12.1 1.66675 11.2334Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.ea75416bfacb01234cb8bcec3fcf86af.svg";
export { ForwardRef as ReactComponent };